
export type LocalStorageKey = "current_order_sheet" | "id_token"

export class LocalStorageWrapper{
    public static Get(key: LocalStorageKey) : string | null {
        return localStorage.getItem(key)
    }
    public static Set(key: LocalStorageKey, value: string): void {
        localStorage.setItem(key, value)
    }
    public static Remove(key: LocalStorageKey) : void {
        return localStorage.removeItem(key)
    }
}